module.exports = __webpack_public_path__ + "view/videoexport.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]&outputPath=view/!./src/view/videoexport.html
// module id = 29
// module chunks = 0